<template>
	<header class="subnav subnav-filters">
		<div class="container d-flex align-items-center justify-content-between">
			<div class="navbar-group"></div>
			<div class="navbar-group actions show">
				<RouterLink
					:to="{ name: 'school-event-wizard' }"
					style="text-decoration: none; color: unset"
					data-cy="nav-wizard-btn"
					v-if="!isDistrict && authStore.hasPolicy('school.events.wizard.execute')"
				>
					<button
						type="button"
						:class="[
							{ selected: $router.currentRoute.value.name === 'school-event-wizard' },
						]"
					>
						<i class="bi-magic"></i>
						<span>Create Event Wizard</span>
					</button>
				</RouterLink>
				<RouterLink
					:to="{ name: 'school-events' }"
					style="text-decoration: none; color: unset"
					data-cy="nav-all-events-btn"
					v-if="!isDistrict && authStore.hasPolicy('school.events.general.read')"
				>
					<button
						type="button"
						:class="[{ selected: $router.currentRoute.value.name === 'school-events' }]"
						@click="$router.push({ name: 'school-events' })"
					>
						<v-icon>mdi-calendar-blank</v-icon>
						<span>All Events</span>
					</button>
				</RouterLink>

				<RouterLink
					:to="{ name: 'school-directory' }"
					style="text-decoration: none; color: unset"
					v-if="!isDistrict && (authStore.hasPolicy('school.directory.classes.read') || authStore.hasPolicy('school.directory.classes.write') || authStore.hasPolicy('school.directory.teacher.read') || authStore.hasPolicy('school.directory.teacher.write') || authStore.hasPolicy('school.directory.parent.read') || authStore.hasPolicy('school.directory.parent.write') || authStore.hasPolicy('school.directory.student.read') || authStore.hasPolicy('school.directory.student.write') || authStore.hasPolicy('school.directory.team.read') || authStore.hasPolicy('school.directory.team.write'))"
				>
					<button
						type="button"
						:class="[
							{ selected: $router.currentRoute.value.name === 'school-directory' },
						]"
						data-cy="nav-directory-btn"
					>
						<v-icon>mdi-account-multiple-outline</v-icon>
						<span>Directory</span>
					</button>
				</RouterLink>
				<RouterLink
					:to="{ name: 'school-integration' }"
					style="text-decoration: none; color: unset"
					data-cy="nav-integration-btn"
					v-if="authStore.hasPolicy('school.integration.read') || authStore.hasPolicy('school.integration.write')"
				>
					<button
						type="button"
						:class="[
							{ selected: $router.currentRoute.value.name === 'school-integration' },
						]"
					>
						<v-icon>mdi-cog-outline</v-icon>
						<span>Integration</span>
					</button>
				</RouterLink>
			</div>
		</div>
	</header>
</template>
<script setup>
import { computed } from "vue";
import { useAuthenticationStore } from "@/stores/authentication";
import { useSchoolStore } from "@/stores/school";

const authStore = useAuthenticationStore();
const schoolStore = useSchoolStore();
const isDistrict = computed(() => schoolStore.isDistrict());
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.navbar-group.actions {
	button {
		@include breakpoints.media-breakpoint-down(sm) {
			span {
				font-size: 13px !important;
			}
		}
		&.selected {
			color: $primary !important;
			box-shadow: 0 0 0 0.125rem rgba(128, 12, 27, 0.125);
		}
	}
}
</style>
